import { AvailabilityWorkflowStatus } from '../service/admin/messages';

export function getAvailabilitySender(report: any, player?: any) {
  const sender = report.sender || {};
  const senderId = String(sender.userId || '');
  const studentId = String(report.playerDetails?.userId || report.playerDetailsData?.id || player?.userId || '');
  let fullName = String(sender.fullName || '').trim();
  if (!fullName && !sender.nameUnavailable && senderId && senderId === studentId) {
    const identity = [player, report.playerDetailsData].find(value => value && String(value.userId || value.id || '') === senderId);
    if (identity) fullName = [identity.firstName, identity.lastName].filter(Boolean).join(' ').trim();
  }
  return {fullName: fullName || (senderId ? 'Name unavailable' : 'Unknown sender'),
    role: senderId && studentId ? (senderId === studentId ? 'Student' : 'Parent') : 'Unknown'};
}

export function getAvailabilitySummary(counts: Partial<Record<AvailabilityWorkflowStatus, number>>, selfService = false) {
  const available = counts.AVAILABLE || 0;
  const unavailable = counts.NOT_AVAILABLE || 0;
  const pending = counts.PENDING || 0;
  const expired = counts.EXPIRED || 0;
  const notRequested = counts.NOT_REQUESTED || 0;
  const noRecipient = counts.NO_RECIPIENT || 0;
  const replied = available + unavailable;
  const total = replied + pending + expired + notRequested + noRecipient;

  if (!total) return { heading: 'No participants', detail: 'Add participants to track availability.' };
  if (replied) return {
    heading: `${available} available · ${unavailable} not available`,
    detail: `${selfService ? 'Availability reported' : 'Replies received'}: ${replied} of ${total} students.`
  };
  if (noRecipient === total) return {
    heading: 'No eligible recipients', detail: 'No linked parent or student account is available to respond.'
  };
  if (selfService) return {
    heading: 'No availability reports yet', detail: 'Families can report availability in the app.'
  };
  if (pending) return { heading: 'Awaiting availability replies', detail: 'No replies received yet.' };
  if (expired) return { heading: 'No replies received', detail: 'The response deadline has passed.' };
  return { heading: 'Availability not requested', detail: 'No availability requests have been sent for these students.' };
}
